import React, { useState } from "react";
import { FaHeart, FaRegHeart } from "react-icons/fa";
import { useFavorites } from "../../context/FavoritesContext";
import { useTheme } from "../../context/ThemeProvider";
import { toast } from "react-toastify";
import useAuth from "../../hooks/useAuth";

const FavoriteButton = ({ videoId, setShowSubscribeModal }) => {
  const { auth } = useAuth();
  const { addFavorite, removeFavorite, isFavorite } = useFavorites();
  const { darkMode } = useTheme();
  
  const [isHovered, setIsHovered] = useState(false);
  const [isAnimating, setIsAnimating] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);

  // Derive active state synchronously from context
  const favorited = isFavorite(videoId);

  const handleClick = async (e) => {
    e.stopPropagation();
    e.preventDefault();

    if (!auth?.RawToken) {
      if (setShowSubscribeModal) setShowSubscribeModal(true);
      return;
    }

    if (isProcessing) return;
    
    // Trigger pop animation immediately
    setIsAnimating(true);
    setTimeout(() => setIsAnimating(false), 300);
    setIsProcessing(true);

    try {
      if (favorited) {
        const result = await removeFavorite(videoId);
        if (result.success) {
          toast.success("Removed from favorites");
        } else {
          toast.error(result.message || "Could not remove video");
        }
      } else {
        const result = await addFavorite(videoId);
        if (result.success) {
          toast.success("Added to favorites");
        } else {
          toast.error(result.message || "Could not save video");
        }
      }
    } finally {
      setIsProcessing(false);
    }
  };

  return (
    <div
      className="relative flex items-center cursor-pointer"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onFocus={() => setIsHovered(true)}
      onBlur={() => setIsHovered(false)}
      onClick={handleClick}
    >
      <div
        className={`h-8 w-8 flex items-center justify-center transition-all duration-200
          ${isAnimating ? "scale-110" : "scale-100"}
          ${
            favorited
              ? "bg-transparent"
              : darkMode
                ? "bg-transparent text-white"
                : "bg-transparent text-gray-700"
          }
        `}
      >
        {favorited ? (
          <FaHeart className="text-red-500 text-[18px] mt-[1px]" />
        ) : (
          <FaRegHeart className="text-[18px] mt-[1px]" />
        )}
      </div>
      <span
        className={`pointer-events-none absolute left-full top-1/2 ml-2 -translate-y-1/2 whitespace-nowrap text-[11px] ${
          darkMode ? "bg-[#1B1D1C] text-white" : "bg-white text-gray-700"
        } ${
          isHovered ? "opacity-100" : "opacity-0"
        } z-20 rounded px-2 py-1 shadow transition-opacity duration-150`}
      >
        {favorited ? "Saved" : "Save"}
      </span>
    </div>
  );
};

export default FavoriteButton;
